import React from 'react';
import { Box } from '@mui/material';
import { colors } from '../../styles/colors';

const PERIODS = [
  { value: '7d', label: '7j' },
  { value: '30d', label: '30j' },
  { value: '90d', label: '90j' },
  { value: '12m', label: '12 mois' },
];

function PeriodSelector({ value = '30d', onChange, accentColor }) {
  const color = accentColor || colors.primary;
  return (
    <Box sx={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
      {PERIODS.map(p => {
        const active = p.value === value;
        return (
          <Box
            key={p.value}
            onClick={() => onChange(p.value)}
            sx={{
              px: 1.5,
              py: 0.5,
              borderRadius: '100px',
              cursor: 'pointer',
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '0.75rem',
              fontWeight: active ? 600 : 500,
              color: active ? '#fff' : colors.textMed,
              bgcolor: active ? color : 'transparent',
              border: `1px solid ${active ? color : colors.borderLight}`,
              transition: 'all 0.25s ease',
              userSelect: 'none',
              '&:hover': {
                borderColor: color,
                color: active ? '#fff' : color,
              },
            }}
          >
            {p.label}
          </Box>
        );
      })}
    </Box>
  );
}

export default PeriodSelector;
